import { CommonModule } from '@angular/common';
import { ContainerLibraryComponent } from './components/container-library/container-library.component';
import { CardModule } from '../card/card.module';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceComponent } from './components/workspace/workspace.component';
import { SharedModule } from '../shared/shared.module';
import { ContainerOverviewComponent } from './components/container-overview/container-overview.component';

@NgModule({
    declarations: [
        ContainerLibraryComponent,
        WorkspaceComponent,
        ContainerOverviewComponent,
    ],
    imports: [
        CommonModule,
        CardModule,
        SharedModule,
        NgbModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    exports: [ContainerLibraryComponent, WorkspaceComponent],
})
export class WorkspaceModule {}
